import {closeModal} from "./utils/common";

export const closePopup = () => {
  const closeButtonElement = document.querySelectorAll(`.js-modal-close`);

  if (closeButtonElement.length) {
    closeButtonElement.forEach((button) => {
      const targetClose = document.querySelector(button.dataset.target);

      button.addEventListener(`click`, () => {
        closeModal(targetClose);
        document.body.classList.remove(`modal-open`);
      });
    });
  }
};
